export default __webpack_public_path__ + "static/media/img5.bef888a2.jpg";